import { useEffect } from 'react'

export function useSmartPolling(
  pollIntervalMillis: number,
  startPolling: (pollIntervalMillis: number) => void,
  stopPolling: () => void
) {
  useEffect(() => {
    // Tabs opened in the background (e.g. cmd-click) mount hidden and never receive a
    // visibilitychange event until first viewed; don't start polling in them.
    if (document.visibilityState === 'visible') {
      startPolling(pollIntervalMillis)
    }
  }, [pollIntervalMillis, startPolling])

  useEffect(() => {
    const handleVisibilityChange = (e: any) => {
      if (document.visibilityState === 'visible') {
        startPolling(pollIntervalMillis)
      } else {
        stopPolling()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [pollIntervalMillis, startPolling, stopPolling])
}
